<template>
  <div
    class="w-full h-full px-4 box-border overflow-auto"
    v-loading="viewLoading"
    @scroll="scrollViewHandle"
  >
    <div class="w-full pt-1 mb-6 flex items-center">
      <span class="mr-4 text-medium text-theme-black-850 leading-22">
        答题结束后显示报告
      </span>
      <el-switch
        size="small"
        :disabled="showReportLoading"
        v-model="topSource.showReportAfterAnswer"
        @change="changeShowReportHandle"
      />
    </div>
    <p class="text-medium-x text-theme-black-850 leading-22 font-semibold">
      测评标题
    </p>
    <el-input
      size="small"
      class="mt-4 mb-6 field_width"
      placeholder="请输入"
      :disabled="titleLoading"
      v-model="title"
      @blur="blurTestTitleHandle"
    />
    <p class="flex items-center justify-between">
      <span class="flex items-center">
        <span class="text-medium-x text-theme-black-850 leading-22 font-semibold">
          测评说明
        </span>
        <el-tooltip content="向答题者说明测评原理、方法、理论、背景等方面">
          <i class="iconfont icon-shuoming text-medium text-theme-black-350 cursor-pointer ml-1"></i>
        </el-tooltip>
      </span>
      <el-button
        type="text"
        size="small"
        :loading="illLoading"
        @click="editTestIllustrateHandle"
        v-if="topSource.instruction !== instructionValue"
      >更新</el-button>
    </p>
    <div class="w-full mt-4 mb-6">
      <senior-editor v-model="instructionValue" image/>
    </div>
    <div class="flex items-center justify-between">
      <p class="flex items-center">
          <span class="text-medium-x text-theme-black-850 leading-22 font-semibold">
          测评结果
        </span>
        <el-tooltip content="告知答题者总得分不同范围内的评语或建议">
          <i class="iconfont icon-shuoming text-medium text-theme-black-350 ml-1 cursor-pointer"></i>
        </el-tooltip>
      </p>
      <span
        class="text-theme text-medium leading-none select-none cursor-pointer"
        @click="addScoreAdviceHandle"
      >
        新增分值及评语
      </span>
    </div>
    <data-table
      class="w-full overflow-hidden"
      cell-class-name="truncate-table-cell-wrap"
      align="left"
      :data="resultList"
      :columns="resultColumns"
      :show-page="false"
      :show-tooltip="true"
    >
      <template #scoreRange="{ row }">
        <span>{{row.scoreLowerBound || 0}}分~{{row.scoreUpperBound || 0}}分</span>
      </template>
      <template #suggestion="{ row }">
        <div class="w-full whitespace-normal">{{getSuggestion(row.suggestion)}}</div>
      </template>
      <template #action="{ row, $index }">
        <el-button
          size="text"
          type="text"
          @click="editScoreAdviceHandle(row, $index)"
        >编辑</el-button>
        <el-button
          size="text"
          type="text"
          :loading="row.removeLoading"
          @click="removeScoreAdviceHandle(row, $index)"
        >删除</el-button>
      </template>
      <template #empty>
        <el-empty :image-size="180"></el-empty>
      </template>
    </data-table>
    <p class="w-full flex items-center">
      <i class="el-icon-warning-outline text-medium text-yellow-theme mr-1"></i>
      <span class="text-small text-yellow-theme leading-22" v-if="topSource.weightValue">
        当前问卷已开启权重设置，总得分 = (维度得分 * 权重比例) + (维度得分 * 权重比例) + …
      </span>
      <span class="text-small text-yellow-theme leading-22" v-else>
        总得分 = 维度得分+维度得分 + …
      </span>
    </p>
    <div class="w-full mt-7 mb-2 flex items-center justify-between">
      <p class="text-medium-x text-theme-black-850 font-semibold leading-22">得分分析</p>
      <el-select size="small" v-model="chartType">
        <el-option
          v-for="item in chartTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <analysis-chart
      ref="achart"
      :type="chartType"
      :source="chart.source"
      :merge-legend="chart.legend"
    />
    <p class="w-full text-small text-yellow-theme leading-22 text-right">
      当前答题分值为系统随机生成，可通过答题获取真实结果
    </p>
    <p class="text-medium-x text-theme-black-850 leading-22 font-semibold">维度结果及建议</p>
    <div class="w-full mt-4 mb-2" v-for="(dm, dmIndex) of dimensionList" :key="dmIndex">
      <div class="w-full flex items-center justify-between text-medium leading-22">
        <span class="text-theme-black-850">{{dm.title || '—'}}</span>
        <span
          class="text-theme select-none cursor-pointer"
          @click="addAdviceResultHandle(dm)"
        >
          新增结果及建议
        </span>
      </div>
      <data-table
        class="w-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        :data="dm.results || []"
        :columns="dmResultColumns"
        :show-page="false"
        :show-tooltip="true"
        v-if="(dm.results || []).length > 0"
      >
        <template #scoreRange="{ row }">
          <span>{{row.scoreLowerBound || 0}}分~{{row.scoreUpperBound || 0}}分</span>
        </template>
        <template #suggestion="{ row }">
          <div class="w-full whitespace-normal">{{getSuggestion(row.suggestion)}}</div>
        </template>
        <template #action="{ row, $index }">
          <el-button
            size="text"
            type="text"
            @click="editAdviceResultHandle(dm, row, $index)"
          >编辑</el-button>
          <el-button
            size="text"
            type="text"
            :loading="row.removeLoading"
            @click="removeAdviceResultHandle(dm, row, $index)"
          >删除</el-button>
        </template>
        <template #empty>
          <el-empty :image-size="180"></el-empty>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash/function'
import { html2text } from '@dygc/shared'
import { createPopup } from '@/assets/js/factory'
import GlobalConfig from '@/global/config'
import AnalysisChart from '@/components/analysis/AnalysisChart'
import SeniorEditor from '@/components/base/SeniorEditor'
import DataTable from '@/components/base/DataTable'
import { chartTypeCode, chartTypes } from '@/global/analysis'
import {
  editDimensionScore,
  getDimensionSettings,
  addResultAdvice,
  editInstruction
} from '@/api/wenjuan/dimensionScore'
import AddAdviceResultDialog from './AddAdviceResultDialog'
import { resultColumns, dmResultColumns } from '../../config/dimension-score'

export default {
  name: 'EvaluationReportSetting',
  components: {
    AnalysisChart,
    SeniorEditor,
    DataTable
  },
  inject: {
    topSource: {
      default: () => ({})
    }
  },
  data() {
    return {
      viewLoading: false,
      showReportLoading: false,
      illLoading: false,
      titleLoading: false,
      title: this.$store.getters.title ?? '',
      instructionValue: this.topSource.instruction ?? '',
      resultList: [],
      resultColumns,
      dimensionList: [],
      dmResultColumns,
      chartTypes,
      chartType: chartTypeCode.LEIDA,
    }
  },
  computed: {
    storeTitle() {
      return this.$store.getters.title;
    },
    chart() {
      const sArr = [5, 10, 15, 20];
      const originSource = [
        { title: '维度A', average: sArr[Math.floor(Math.random() * 4)] },
        { title: '维度B', average: sArr[Math.floor(Math.random() * 4)] },
        { title: '维度C', average: sArr[Math.floor(Math.random() * 4)] },
        { title: '维度D', average: sArr[Math.floor(Math.random() * 4)] },
      ]
      const source = !this.topSource.standardValue ? originSource
        : originSource.map((m) => ({
          ...m,
          standard: sArr[Math.floor(Math.random() * 4)]
        }));
      const legend = [
        { legend: '标准分值', show: this.topSource.standardValue },
        { legend: '答题分值', show: true }
      ];
      return { source, legend }
    }
  },
  watch: {
    storeTitle(title) {
      if (title !== this.title) {
        this.title = title;
      }
    }
  },
  created() {
    this.scrollViewHandle = debounce(this.scrollView.bind(this), 500, { leading: true, trailing: false });
  },
  mounted() {
    this.getDetail();
  },
  beforeDestroy() {
    this.scrollViewHandle.cancel();
  },
  methods: {
    getSuggestion(str) {
      return html2text(str);
    },
    getDetail() {
      this.viewLoading = true;
      getDimensionSettings().then((res) => {
        const { dimensions, results } = res.data.data || {};
        this.resultList = results || [];
        this.dimensionList = dimensions || [];
      }).catch(() => {
        this.$message.error('获取测评报告详情失败');
      }).finally(() => {
        this.viewLoading = false;
      });
    },
    changeShowReportHandle() {
      const { showReportAfterAnswer } = this.topSource;
      const req = { showReportAfterAnswer };
      this.showReportLoading = true;
      editDimensionScore(req, req).then(res => {
        const { code, msg } = res.data || {};
        if (code === 0) {
          this.$message.success('设置答题结束显示报告成功');
        } else {
          this.$message.error(msg ?? '设置答题结束显示报告失败');
        }
      }).catch(() => {
        this.$message.error('设置答题结束显示报告失败');
      }).finally(() => {
        this.showReportLoading = false;
      });
    },
    blurTestTitleHandle() {
      if (this.storeTitle === this.title) {
        return;
      }
      if (this.title.length === 0) {
        this.$message.warning('请填写标题');
        this.title = this.storeTitle;
        return;
      }
      if (this.title.length > 200) {
        this.$message.warning('标题字数最大不能超过200字');
        this.title = this.storeTitle;
        return;
      }
      const surveyId = GlobalConfig.getSurveyId();
      this.titleLoading = true;
      this.$store.dispatch(
        'updateSurveyTitleAndWelcome',
        { surveyId, title: this.title, titlex: this.title }
      ).then(() => {
        this.$message.success('修改标题成功');
        this.$surveyBus.$emit('showDraft', true);
      }).finally(() => {
        this.titleLoading = false;
      });
    },
    editTestIllustrateHandle() {
      this.illLoading = true;
      editInstruction(this.instructionValue).then(res => {
        const { code, msg } = res.data || {};
        if (code === 0) {
          this.$message.success('编辑测评说明成功');
          this.topSource.instruction = this.instructionValue;
        } else {
          this.$message.error(msg ?? '编辑测评说明失败');
        }
      }).catch(() => {
        this.$message.error('编辑测评说明失败');
      }).finally(() => {
        this.illLoading = false;
      });
    },
    addScoreAdviceHandle() {
      const scoreRanges = this.resultList.map(
        m => ({ minScore: m.scoreLowerBound, maxScore: m.scoreUpperBound })
      );
      createPopup(AddAdviceResultDialog, {
        modeType: 'testResult',
        handlerType: 'add',
        dialogTitle: '新增分值及评语',
        scoreRanges,
        onConfirm: this.getDetail
      });
    },
    editScoreAdviceHandle(rsItem, index) {
      const scoreRanges = this.resultList.filter((f, i) => i !== index).map(
        m => ({ minScore: m.scoreLowerBound, maxScore: m.scoreUpperBound })
      );
      const { scoreLowerBound, scoreUpperBound, suggestion } = rsItem;
      createPopup(AddAdviceResultDialog, {
        modeType: 'testResult',
        handlerType: 'edit',
        dialogTitle: '编辑分值及评语',
        scoreRanges,
        source: {
          key: index,
          scoreLowerBound,
          scoreUpperBound,
          suggestion
        },
        onConfirm: this.getDetail
      });
    },
    async removeScoreAdviceHandle(rsItem, index) {
      try {
        await this.$confirm('点击确定，该分值及相应评语将删除且不可恢复。您确定要删除么？', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      try {
        const params = {
          dimensionOrSuggestion: 0,
          type: 2, // 删除
          key: index,
        };
        this.$set(rsItem, 'removeLoading', true);
        const { data } = await addResultAdvice({}, params);
        const { code, msg } = data || {};
        if (code === 0) {
          this.$message.success('删除分值及评语成功');
          this.getDetail();
        } else {
          this.$message.error(msg ?? '删除分值及评语失败');
        }
      } catch (e) {
        this.$message.error('删除分值及评语失败');
      } finally {
        this.$set(rsItem, 'removeLoading', false);
      }
    },
    addAdviceResultHandle(dmItem) {
      const scoreRanges = (dmItem.results || []).map(
        m => ({ minScore: m.scoreLowerBound, maxScore: m.scoreUpperBound })
      );
      createPopup(AddAdviceResultDialog, {
        modeType: 'adviceResult',
        handlerType: 'add',
        dialogTitle: '新增结果及建议',
        scoreRanges,
        source: {
          title: dmItem.title,
          score: dmItem.score
        },
        onConfirm: this.getDetail
      });
    },
    editAdviceResultHandle(dmItem, rsItem, index) {
      const scoreRanges = (dmItem.results || []).filter((f,i) => i !== index).map(
        m => ({ minScore: m.scoreLowerBound, maxScore: m.scoreUpperBound })
      );
      const { scoreLowerBound, scoreUpperBound, suggestion } = rsItem;
      createPopup(AddAdviceResultDialog, {
        modeType: 'adviceResult',
        handlerType: 'edit',
        dialogTitle: '编辑结果及建议',
        scoreRanges,
        source: {
          title: dmItem.title,
          score: dmItem.score,
          key: index,
          scoreLowerBound,
          scoreUpperBound,
          suggestion
        },
        onConfirm: this.getDetail
      });
    },
    async removeAdviceResultHandle(dmItem, rsItem, index) {
      try {
        await this.$confirm('点击确定，该结果下分值及相应建议将删除且不可恢复。您确定要删除么？', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      try {
        const params = {
          dimensionOrSuggestion: 1,
          type: 2, // 删除
          key: index,
          title: dmItem.title
        };
        this.$set(rsItem, 'removeLoading', true);
        const { data } = await addResultAdvice({}, params);
        const { code, msg } = data || {};
        if (code === 0) {
          this.$message.success('删除结果及建议成功');
          this.getDetail();
        } else {
          this.$message.error(msg ?? '删除结果及建议失败');
        }
      } catch (e) {
        this.$message.error('删除结果及建议失败');
      } finally {
        this.$set(rsItem, 'removeLoading', false);
      }
    },
    scrollView() {
      const expandeds = document.querySelectorAll('[aria-expanded="true"]');
      if (expandeds.length > 0) {
        for (const exp of expandeds) {
          exp.click();
          exp.blur();
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.field_width {
  width: 427px;
}
</style>